import { createAction } from '@reduxjs/toolkit';

const setPermissionState = createAction(
  'local_network_access/setPermissionState'
);
const dismissBanner = createAction('local_network_access/dismissBanner');
const resetBannerDismissed = createAction(
  'local_network_access/resetBannerDismissed'
);

export { setPermissionState, dismissBanner, resetBannerDismissed };
